import { ReactElement } from 'react'
import { useTheme } from '@mui/material'
import { ToggleButtonDropDown, ToggleDropDownOptions } from '@ui/actions'
import { Slab } from '@ui/icons'

/** Drawing tools reused in the IFC importer (roof surfaces + walls). */
export type IFCDrawMode = 'draw-roofs' | 'draw-walls'

const drawOptions: { label: string; value: IFCDrawMode }[] = [
  { label: 'Dachflächen (3D)', value: 'draw-roofs' },
  { label: 'Wände (2D)', value: 'draw-walls' },
]

interface Props {
  onClick: (value: IFCDrawMode) => void
  value?: IFCDrawMode
}

/**
 * "Zeichnen" dropdown for the IFC import toolbar — a scoped subset of the structural-planning
 * drawing tools (roof/slab surfaces and walls).
 */
const IFCDrawToolSelect = ({ onClick, value }: Props): ReactElement => {
  const theme = useTheme()

  return (
    <ToggleButtonDropDown
      hint="Zeichnen"
      openAbove
      tooltipPlacement="top"
      toggleType="click"
      closeOnChildrenClick
      style={{
        color: theme.palette.grey[800],
        backgroundColor: value ? theme.palette.grey[400] : undefined,
        borderColor: theme.palette.grey[600],
      }}
      Icon={Slab}
      data-cy="btn-ifc-draw-select"
    >
      <ToggleDropDownOptions value={value} onClick={onClick} options={drawOptions} />
    </ToggleButtonDropDown>
  )
}

export default IFCDrawToolSelect
